import { oc } from "@orpc/contract";
import { z } from "zod";

const ManagerOptionSchema = z.object({
    id: z.string(),
    displayName: z.string(),
    jobTitle: z.string(),
    imageUrl: z.string().optional()
});
export type ManagerOption = z.infer<typeof ManagerOptionSchema>;

const SearchReportingManagersInputSchema = z.object({
    q: z.string().optional(),
    restrictToMemberIds: z.array(z.string()).optional(),
    continuationToken: z.string().optional(),
    pageSize: z.number().int().positive().default(10)
});
export type SearchReportingManagersInput = z.infer<typeof SearchReportingManagersInputSchema>;

const SearchReportingManagersOutputSchema = z.object({
    items: z.array(ManagerOptionSchema),
    totalCount: z.number(),
    continuationToken: z.string().optional()
});
export type SearchReportingManagersOutput = z.infer<typeof SearchReportingManagersOutputSchema>;

const ReviewCycleOptionSchema = z.object({
    id: z.string(),
    label: z.string(),
    activity: z.enum(["Active", "Locked"])
});
export type ReviewCycleOption = z.infer<typeof ReviewCycleOptionSchema>;

const SearchReviewCyclesInputSchema = z.object({
    q: z.string().optional(),
    restrictToReviewCycleIds: z.array(z.string()).optional(),
    continuationToken: z.string().optional(),
    pageSize: z.number().int().positive().default(20)
});
export type SearchReviewCyclesInput = z.infer<typeof SearchReviewCyclesInputSchema>;

const SearchReviewCyclesOutputSchema = z.object({
    items: z.array(ReviewCycleOptionSchema),
    totalCount: z.number(),
    continuationToken: z.string().optional()
});
export type SearchReviewCyclesOutput = z.infer<typeof SearchReviewCyclesOutputSchema>;

const AttributeOptionSchema = z.object({
    value: z.string(),
    label: z.string(),
    optionId: z.number().int().optional()
});
export type AttributeOption = z.infer<typeof AttributeOptionSchema>;

const AttributeOptionsOutputSchema = z.object({
    items: z.array(AttributeOptionSchema)
});

const SearchJobTitlesInputSchema = z.object({
    q: z.string().optional(),
    continuationToken: z.string().optional(),
    pageSize: z.number().int().positive().default(50)
});
export type SearchJobTitlesInput = z.infer<typeof SearchJobTitlesInputSchema>;

const SearchJobTitlesOutputSchema = z.object({
    items: z.array(AttributeOptionSchema),
    totalCount: z.number(),
    continuationToken: z.string().optional()
});
export type SearchJobTitlesOutput = z.infer<typeof SearchJobTitlesOutputSchema>;

const SegmentOptionSchema = z.object({
    id: z.string(),
    name: z.string(),
    memberCount: z.number()
});
export type SegmentOption = z.infer<typeof SegmentOptionSchema>;

const SearchSegmentsInputSchema = z.object({
    q: z.string().optional(),
    continuationToken: z.string().optional(),
    pageSize: z.number().int().positive().default(20)
});
export type SearchSegmentsInput = z.infer<typeof SearchSegmentsInputSchema>;

const SearchSegmentsOutputSchema = z.object({
    items: z.array(SegmentOptionSchema),
    totalCount: z.number(),
    continuationToken: z.string().optional()
});
export type SearchSegmentsOutput = z.infer<typeof SearchSegmentsOutputSchema>;

export const filterOptionsContract = {
    searchReportingManagers: oc.route({ method: "GET", path: "/search-reporting-managers" }).input(SearchReportingManagersInputSchema).output(SearchReportingManagersOutputSchema),
    searchReviewCycles: oc.route({ method: "GET", path: "/search-review-cycles" }).input(SearchReviewCyclesInputSchema).output(SearchReviewCyclesOutputSchema),
    listDepartments: oc.route({ method: "GET", path: "/list-departments" }).output(AttributeOptionsOutputSchema),
    listGenders: oc.route({ method: "GET", path: "/list-genders" }).output(AttributeOptionsOutputSchema),
    listWorkLocations: oc.route({ method: "GET", path: "/list-work-locations" }).output(AttributeOptionsOutputSchema),
    listJobLevels: oc.route({ method: "GET", path: "/list-job-levels" }).output(AttributeOptionsOutputSchema),
    searchJobTitles: oc.route({ method: "GET", path: "/search-job-titles" }).errors({ UPSTREAM_FAILURE: {} }).input(SearchJobTitlesInputSchema).output(SearchJobTitlesOutputSchema),
    searchSegments: oc.route({ method: "GET", path: "/search-segments" }).errors({ UPSTREAM_FAILURE: {} }).input(SearchSegmentsInputSchema).output(SearchSegmentsOutputSchema)
};
